<template>
	<div class="category-content order-content">
		<div class="main-width">
			<div class="manage-center-content">
				<div class="manage-slide">
					<el-col>
	    <el-menu :default-active="defaultActive" class="el-menu-vertical-demo" :default-openeds="defaultOpen">
	    	<el-submenu index="1">
	        	<template slot="title">下载列表</template>
	        	<el-menu-item index="1-1">
	        		<template slot="title"><router-link tag="a" :to="{name: 'DownloadList'}">下载列表</router-link></template>
	        	</el-menu-item>
	      	</el-submenu>
	    </el-menu>
  	</el-col>
				</div>
				<div>
					<router-view></router-view>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

	export default{
    	data(){
			return {
				defaultOpen: ['1'],
				defaultActive: "1-1"
			}
		},
		created(){
        	// this.routeChange();
        },
        mounted(){this.routeChange();},
        methods: {
        	routeChange(){
            var url = window.location.href;
            var strs = url.split("/");
            var str = strs[strs.length - 1];
            if(str == 'downloadlist'){
              this.defaultActive = "1-1";
            }
          }
        },
	}
</script>



// WEBPACK FOOTER //
// Download.vue?42ebfe8e